module.exports = __webpack_public_path__ + "static/img/pass-child.e11c9131.png";